var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14 3.987a68 68 0 0 0-6.68-.334q-1.98 0-3.96.2L2 3.987M5.667 3.313l.147-.873C5.92 1.807 6 1.333 7.127 1.333h1.747c1.126 0 1.213.5 1.313 1.114l.147.866M12.567 6.093l-.433 6.714c-.074 1.046-.134 1.86-1.994 1.86H5.86c-1.86 0-1.92-.814-1.993-1.86l-.433-6.714M6.887 11h2.22M6.333 8.333h3.333"
  })));
};
export default SvgTrash;